var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonApps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.25V4.5H2.25V2.25H4.5ZM5.625 1.125H1.125V5.625H5.625V1.125ZM10.125 2.25V4.5H7.875V2.25H10.125ZM11.25 1.125H6.75V5.625H11.25V1.125ZM15.75 2.25V4.5H13.5V2.25H15.75ZM16.875 1.125H12.375V5.625H16.875V1.125ZM4.5 7.875V10.125H2.25V7.875H4.5ZM5.625 6.75H1.125V11.25H5.625V6.75ZM10.125 7.875V10.125H7.875V7.875H10.125ZM11.25 6.75H6.75V11.25H11.25V6.75ZM15.75 7.875V10.125H13.5V7.875H15.75ZM16.875 6.75H12.375V11.25H16.875V6.75ZM4.5 13.5V15.75H2.25V13.5H4.5ZM5.625 12.375H1.125V16.875H5.625V12.375ZM10.125 13.5V15.75H7.875V13.5H10.125ZM11.25 12.375H6.75V16.875H11.25V12.375ZM15.75 13.5V15.75H13.5V13.5H15.75ZM16.875 12.375H12.375V16.875H16.875V12.375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonApps);
export default __webpack_public_path__ + "static/media/carbon_apps.6dc4c7e94b9dd3e1153bf2edf49f949d.svg";
export { ForwardRef as ReactComponent };